export default __webpack_public_path__ + "static/media/WorkspaceBirthdaySlack.a9996013.png";